import { apiClient } from './client'
import type { CurrentSmartItineraryResponse, EventFavoritesResponse, SavedSmartItinerary, SmartItineraryAdjustmentsResponse, SmartItineraryOptions, SmartItineraryPreview, SmartItineraryReflowResponse, SmartItineraryShare } from '../types/eventPlan'

function snapshotPayload(plan: SmartItineraryPreview) {
  return {
    selection: plan.selection,
    days: plan.days.map((day) => ({ date: day.date, event_ids: day.events.map((event) => event.id) })),
    pinned_event_ids: plan.pinned_event_ids || [],
  }
}

export const eventPlansApi = {
  options: () => apiClient.get<SmartItineraryOptions>('/api/event-plans/options'),
  favorites: () => apiClient.get<EventFavoritesResponse>('/api/event-plans/favorites'),
  favorite: (eventId: string) =>
    apiClient.put<EventFavoritesResponse>(`/api/event-plans/favorites/${encodeURIComponent(eventId)}`, {}),
  unfavorite: (eventId: string) =>
    apiClient.delete<EventFavoritesResponse>(`/api/event-plans/favorites/${encodeURIComponent(eventId)}`),
  preview: (eventTypes: string[], dates: string[], bufferMinutes: number) =>
    apiClient.post<SmartItineraryPreview>('/api/event-plans/preview', {
      event_types: eventTypes,
      dates,
      buffer_minutes: bufferMinutes,
    }),
  adjustments: (
    eventTypes: string[],
    date: string,
    bufferMinutes: number,
    plannedEventIds: string[],
    targetEventId: string,
    pinnedEventIds: string[],
  ) => apiClient.post<SmartItineraryAdjustmentsResponse>('/api/event-plans/adjustments', {
    event_types: eventTypes,
    date,
    buffer_minutes: bufferMinutes,
    planned_event_ids: plannedEventIds,
    target_event_id: targetEventId,
    pinned_event_ids: pinnedEventIds,
  }),
  reflow: (
    eventTypes: string[],
    date: string,
    bufferMinutes: number,
    plannedEventIds: string[],
    targetEventId: string,
    replacementEventId: string,
    pinnedEventIds: string[],
  ) => apiClient.post<SmartItineraryReflowResponse>('/api/event-plans/reflow', {
    event_types: eventTypes,
    date,
    buffer_minutes: bufferMinutes,
    planned_event_ids: plannedEventIds,
    target_event_id: targetEventId,
    replacement_event_id: replacementEventId,
    pinned_event_ids: pinnedEventIds,
  }),
  createShare: (plan: SmartItineraryPreview) =>
    apiClient.post<SmartItineraryShare>('/api/event-plans/shares', snapshotPayload(plan)),
  share: (shareId: string) =>
    apiClient.get<SmartItineraryShare>(`/api/event-plans/shares/${encodeURIComponent(shareId)}`),
  importShare: (shareId: string) =>
    apiClient.post<SavedSmartItinerary>(`/api/event-plans/shares/${encodeURIComponent(shareId)}/import`, {}),
  current: () => apiClient.get<CurrentSmartItineraryResponse>('/api/event-plans/current'),
  saveCurrent: (plan: SmartItineraryPreview) =>
    apiClient.put<SavedSmartItinerary>('/api/event-plans/current', snapshotPayload(plan)),
  deleteCurrent: () => apiClient.delete<{ deleted: boolean }>('/api/event-plans/current'),
}
